export const scrollToMessage = (
  messageId: string,
  arg: ScrollIntoViewOptions = { block: 'center', behavior: 'smooth' },
) => {
  const el = document.getElementById(messageId);
  el?.scrollIntoView(arg);
};
